// @flow

import composeAssetsDataTable from './datatable'
export default composeAssetsDataTable

export {
  ATTR_ASSET_ID,
  ATTR_LABEL,
  ATTR_CATEGORY,
  ATTR_SHAPE,
  ATTR_AREA,
  ATTR_MAP_VIEW,
} from './constants'
